<template>
    <div>
        <div class="card" v-if="technicianApplication.subCategory !== 'FULL'">
            <div class="card-header">
                <span v-if="isGuestApp">Work Dates, </span>
                {{getSSSectionLabel}} & Establishment</div>
            <div class="card-body">
                <div v-if="isGuestApp">
                    <b-row>
                        <b-col>
                            Starting and anticipated completion dates of work in Minnesota.
                        </b-col>
                    </b-row>

                    <div role="alert">
                        <b-row>
                            <b-col>
                                <div class="text-danger" v-if="this.mnSupervisor.length > 0 && !this.validateDates(mnSupervisor, technicianApplication)">Work Dates cannot exceed 30 days.
                                    If you need licensure for more then 30 days, please apply for a Temporary or Full license.</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="text-danger" v-if="this.mnSupervisor.length > 0 && !this.validateYear(mnSupervisor)">Work Dates must all be in the same calendar year.
                                    Applications for the next calendar year may be submitted after November 1st.</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="text-danger" v-if="!$v.mnSupervisor.required || !$v.mnSupervisor.minLength">At least one valid
                                    <span v-if="isGuestApp">Work Date with </span>{{getSSSectionLabel}} and Establishment is required</div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div v-for="(sup, index) in mnSupervisor" :key="sup.id">
                    <b-row v-if="isGuestApp">
                        <b-col cols="12" lg="3">
                            <BaseDateInput v-model="sup.workDate.startDate"
                                           :v="$v.mnSupervisor.$each[index].workDate.startDate"
                                           slug="startDate"
                                           label="Start Date"
                                           :key="index"
                                           :setId="'startDate'+index"
                                           :messages="opts.wdStartDateMessages"
                            />
                        </b-col>
                        <b-col cols="12" lg="3">
                            <BaseDateInput v-model="sup.workDate.endDate"
                                           :v="$v.mnSupervisor.$each[index].workDate.endDate"
                                           slug="endDate"
                                           label="End Date"
                                           :key="index"
                                           :setId="'endDate'+index"
                                           :messages="opts.wdEndDateMessages"
                            />
                        </b-col>
                        <b-col cols="4" class="d-flex align-items-center">
                            <button class="btn btn-danger" @click="removeSupervisor(index)">
                                Remove {{getSSSectionLabel}}
                            </button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="sup.licenseNbr"
                                           :v="$v.mnSupervisor.$each[index].licenseNbr"
                                           slug="licenseNbr"
                                           :label="getSSLicenseLabel"
                                           :key="index"
                                           :setId="'supLicNbr'+index"
                                           @input="setName(sup.licenseNbr, index)"
                            />
                        </b-col>

                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="sup.name"
                                           :v="$v.mnSupervisor.$each[index].name"
                                           slug="name"
                                           :label="getSSNameLabel"
                                           :key="index"
                                           :setId="'supName'+index"
                                           :plaintext="true"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <BaseTextInput v-model="sup.establishment.supervisedEstName"
                                           :v="$v.mnSupervisor.$each[index].establishment.supervisedEstName"
                                           slug="supervisedEstName"
                                           :label="getSupEstLabel"
                                           setId="supervisedEstName"
                            />
                        </b-col>
                        <b-col cols="4">
                            <BaseMaskedTextInput v-model="sup.establishment.supervisedEstPhoneNumber"
                                                 :v="$v.mnSupervisor.$each[index].establishment.supervisedEstPhoneNumber"
                                                 slug="supervisedEstPhoneNumber"
                                                 label="Establishment Phone Number"
                                                 setId="supervisedEstPhoneNumber"
                                                 mask="(###)###-####"
                            />
                        </b-col>
                        <b-col cols="4">
                            <BaseTextInput v-model="sup.establishment.supervisedEstWebsite"
                                           :v="$v.mnSupervisor.$each[index].establishment.supervisedEstWebsite"
                                           slug="supervisedEstWebsite"
                                           label="Establishment Website"
                                           setId="supervisedEstWebsite"
                            />
                        </b-col>
                    </b-row>
                  <b-row>
                    <b-col cols="4">
                      <BaseTextInput v-model="sup.establishment.supervisedEstLicense"
                                     :v="$v.mnSupervisor.$each[index].establishment.supervisedEstLicense"
                                     slug="supervisedEstLicense"
                                     label="Establishment License Number"
                                     setId="supervisedEstLicense"
                      />
                    </b-col>
                  </b-row>
                    <b-row>
                        <b-col cols="12" lg="12">
                            <BaseTextInput v-model="sup.establishment.supervisedEstFullAddress"
                                           :v="$v.mnSupervisor.$each[index].establishment.supervisedEstFullAddress"
                                           slug="supervisedEstFullAddress"
                                           label="Establishment Address"
                                           tip="Please include street address, city, state, postal code, and country"
                                           setId="supervisedEstFullAddress"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-for="(hrs, idx) in sup.establishment.establishmentHours" :key="hrs.id">
                        <b-col cols="6">
                            <form-group label="Establishment Days" :validator="$v.mnSupervisor.$each[index].establishment.establishmentHours.$each[idx].days">
                                <b-form-checkbox-group
                                        :id="'days'+index+'-'+idx"
                                        v-model="hrs.days"
                                        :options="opts.dayTypeOptions"
                                ></b-form-checkbox-group>
                            </form-group>
                        </b-col>
                        <b-col cols="4">
                            <BaseTextInput v-model="hrs.hours"
                                           :v="$v.mnSupervisor.$each[index].establishment.establishmentHours.$each[idx].hours"
                                           :id="'hours'+index+'-'+idx"
                                           slug="hours"
                                           label="Hours"
                                           :key="index"
                                           :setId="'hours'+index"
                            />
                        </b-col>

                        <b-col cols="2" class="d-flex align-items-center">
                            <button class="btn btn-danger" @click="removeEstHours(index, idx)">
                                Remove Hours
                            </button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <button class="btn btn-secondary" @click="addEstHours(index)">
                                Add Additional Hours
                            </button>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <b-col>
                        <button class="btn btn-outline-primary mt-2" @click="addSupervisor">
                            Add Another {{getSSSectionLabel}}
                        </button>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card" v-if="technicianApplication.subCategory === 'FULL'">
            <div class="card-header">Employment History</div>
            <div class="card-body">

                <b-row class="mt-3">
                    <b-col>
                        List all body art work/employment you have had for the last five years. List the most current first. Include all body art work,
                        regardless of employment status.
                    </b-col>
                </b-row>
                <div v-for="(employer, index) in employers" :key="employer.employerId">
                    <b-row>
                        <b-col cols="12" lg="4">
                            <EmployerAutosuggestInput v-model="employer.name"
                                        :v="$v.employers.$each[index].name"
                                        slug="name"
                                        label="Employer/ Establishment Name"
                                        :key="index"
                                        v-on:employer="updateEmployer($event, index)"
                                        :setId="'name'+index"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="employer.streetAddress"
                                        :v="$v.employers.$each[index].streetAddress"
                                        slug="streetAddress"
                                        label="Street Address"
                                        :key="index"
                                        :setId="'streetAddress'+index"
                            />
                        </b-col>
                        <b-col cols="12" lg="3">
                            <BaseTextInput v-model="employer.city"
                                        :v="$v.employers.$each[index].city"
                                        slug="city"
                                        label="City"
                                        :key="index"
                                        :setId="'city'+index"
                            />
                        </b-col>
                        <b-col cols="12" lg="3">
                            <BaseSelector v-model="employer.state"
                                        :v="$v.employers.$each[index].state"
                                        label="State"
                                        slug="state"
                                        :options=opts.stateOptions
                                        :key="index"
                                        :setId="'state'+index"
                            />
                        </b-col>
                        <b-col cols="12" lg="2">
                            <BaseMaskedTextInput v-model="employer.postalCode"
                                        :v="$v.employers.$each[index].postalCode"
                                        slug="postalCode"
                                        label="ZIP"
                                        :key="index"
                                        :setId="'postalCode'+index"
                                        mask="#####-####"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="6">
                            <BaseMaskedTextInput v-model="employer.phone"
                                        :v="$v.employers.$each[index].phone"
                                        slug="phone"
                                        label="Phone"
                                        :key="index"
                                        :setId="'phone'+index"
                                        mask="(###)###-####"
                            />
                        </b-col>
                        <b-col cols="12" lg="6">
                            <BaseTextInput v-model="employer.emailAddress"
                                        :v="$v.employers.$each[index].emailAddress"
                                        slug="emailAddress"
                                        label="Email Address"
                                        :key="index"
                                        :setId="'emailAddress'+index"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <BaseDateInput v-model="employer.startDate"
                                        :v="$v.employers.$each[index].startDate"
                                        label="Start Date"
                                        slug="startDate"
                                        :key="index"
                                        :setId="'startDate'+index"
                                        :messages="opts.startDateMessages"
                            />
                        </b-col>
                        <b-col cols="12" lg="4">
                            <BaseDateInput v-model="employer.endDate"
                                        :v="$v.employers.$each[index].endDate"
                                        label="End Date"
                                        slug="endDate"
                                        :key="index"
                                        tip="If you are currently working at this location please leave the end date blank"
                                        :setId="'endDate'+index"
                                        :messages="opts.endDateMessages"
                            />
                        </b-col>
                        <b-col cols="12" lg="4" class="d-flex align-items-center">
                            <button class="btn btn-secondary" @click="removeEmployer(index)">
                                Remove Employer
                            </button>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <b-col>
                        <button class="btn btn-secondary" @click="addEmployer">
                            Add Another Employer
                        </button>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>

</template>
<script>
import { commonOptions } from '@/mixins/commonOptions.js'
import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
import BaseSelector from '@/components/templates/input/BaseSelector.vue'
import BaseDateInput from '@/components/templates/input/BaseDateInput.vue'
import EmployerAutosuggestInput from '@/components/templates/input/EmployerAutosuggestInput.vue'
import { required, requiredIf, email, url, minLength, maxLength } from 'vuelidate/lib/validators'
import BaseMaskedTextInput from "../templates/input/BaseMaskedTextInput";
import minDate from '@/validators/minDate'
import maxDate from '@/validators/maxDate'
import license from '@/validators/license'
import { dateAndYearMixin } from '@/mixins/dateAndYear.js'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  });

    export default {
        data() {
            return {
                //for form
                mnSupervisor: [{
                    id: null,
                    name: null,
                    licenseNbr: null,
                    workDate: null,
                    establishment: {
                        establishmentId: null,
                        supervisedEstName: null,
                        supervisedEstFullAddress: null,
                        supervisedEstWebsite: null,
                        supervisedEstLicense: null,
                        supervisedEstPhoneNumber: null,
                        establishmentHours: [{
                            id: null,
                            hours: null,
                            days: []
                        }],
                    }
                }],
                employers: [{
                    employerId : null,
                    applicatonId: null,
                    name: null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    postalCode: null,
                    phone: null,
                    emailAddress: null,
                    startDate: null,
                    endDate: null
                }],
                opts: {
                    startDateMessages: {
                        minDate: 'Start Date must be after 01/01/1900.',
                        maxDate: 'Start Date can not be in the future.'
                    },
                    endDateMessages: {
                        minDate: 'End Date must be after Start Date',
                        maxDate: 'End Date can not be in the future.'
                    },
                    wdStartDateMessages: {
                        minDate: 'Start Date must be in the future.'
                    },
                    wdEndDateMessages: {
                        minDate: 'End Date must be after Start Date',
                        startDefined: 'Start Date must be entered'
                    },
                    dayTypeOptions: []
                },
            }
        },
        components: {
            BaseTextInput,
            BaseMaskedTextInput,
            BaseSelector,
            BaseDateInput,
            EmployerAutosuggestInput
        },
        mixins: [
            commonOptions,
            dateAndYearMixin
        ],
        props: {
            technicianApplication: Object
        },
        validations() {
            return {
                mnSupervisor: {
                    required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }),
                    minLength: minLength(1),
                    $each: {
                        name: { required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }) },
                        licenseNbr: { required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }),
                            minLength: minLength(6),
                            maxLength: maxLength(6), 
                            license: license(this.technicianApplication.license ? this.technicianApplication.license.licenseType : null) },
                        workDate: {
                            required: requiredIf(function() { return this.technicianApplication.subCategory === 'GUEST'}),
                            startDate: {
                                required: requiredIf(function() { return this.technicianApplication.subCategory === 'GUEST'}),
                                minDate: minDate(new Date())
                            },
                            endDate: {
                                required: requiredIf(function() { return this.technicianApplication.subCategory === 'GUEST'}),
                                minDate: minDate(">"),
                            }
                        },
                        establishment: {
                            supervisedEstName: { required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }) },
                            supervisedEstFullAddress: { required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }) },
                            supervisedEstWebsite: { required: false, maxLength: maxLength(75) },
                            supervisedEstLicense: { required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }), maxLength: maxLength(6), minLength: minLength(6) },
                            supervisedEstPhoneNumber: { required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }), minLength: minLength(13) },
                            establishmentHours: {
                                required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }),
                                $each: {
                                    hours: { required:
                                            requiredIf((object) => {
                                                return this.technicianApplication.subCategory !== 'FULL'
                                                    && !object.days.every(d => d === 'APT')
                                            })
                                    },
                                    days: {
                                        required: requiredIf(function() { return this.technicianApplication.subCategory !== 'FULL' }),
                                        minLength: minLength(1)
                                    }
                                }
                            },
                        }
                    }
                },
                employers: {
                    required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }),
                    $each: {
                        employerId : { required: false },
                        applicatonId: { required: false },
                        name: { required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }) },
                        streetAddress: { required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }) },
                        city: { required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }) },
                        state: { required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }) },
                        postalCode: {
                            required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }),
                            maxLength: maxLength(10), minLength: minLength(5)
                        },
                        phone: {
                            required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }),
                            minLength: minLength(13)
                        },
                        emailAddress: {
                            required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }),
                            email
                        },
                        startDate: { required: requiredIf(function() { return this.technicianApplication.subCategory == 'FULL' }),
                                     minDate: minDate(new Date('1900-01-01')),
                                     maxDate: maxDate(new Date())
                        },
                        endDate: { required: false,
                                   maxDate: maxDate(new Date()),
                                   minDate: minDate(">")
                        }
                    }
                },
                form: ['mnSupervisor','employers' ]
            }
        },
        
        watch: {
            technicianApplication() {
                for (var prop in this.technicianApplication) {
                    if (this.hasOwnProperty(prop)) {
                        this[prop] = this.technicianApplication[prop];                        
                    }
                }

                if (this.mnSupervisor != null) {
                    this.mnSupervisor.forEach(sup => {
                        if(sup.workDate === null && this.isGuestApp) {
                            sup.workDate = {
                                id: null,
                                startDate: '',
                                endDate: '',
                            }
                        }
                        if (sup.establishment.establishmentHours === null ) {
                            sup.establishment.establishmentHours =
                                [{
                                    id: null,
                                    hours: null,
                                    days: []
                                }]
                        } else {
                            sup.establishment.establishmentHours.forEach((hrs) => {
                                if (hrs.days.some(d => d.code != undefined)) {
                                    hrs.days = hrs.days.map(d => d.code)
                                }
                            })
                        }
                    })
                }

                if (this.technicianApplication.employers == null) {
                    this.employers= [{
                        employerId : null,
                        applicatonId: null,
                        name: null,
                        streetAddress: null,
                        city: null,
                        state: null,
                        postalCode: null,
                        phone: null,
                        emailAddress: null,
                        startDate: null,
                        endDate: null
                    }]
                }
            }
        },
        
        computed: {
            isGuestApp() {
                return this.technicianApplication && this.technicianApplication.subCategory === 'GUEST'
            },
            getSSLicenseLabel() {
                if (this.technicianApplication.subCategory === 'GUEST') {
                    return "Sponsor's Minnesota license number"
                } else {
                    return "Supervisor's Minnesota license number"
                }
            },
            getSSNameLabel() {
                if (this.technicianApplication.subCategory === 'GUEST') {
                    return "Name of Minnesota licensed Sponsor" 
                } else {
                    return "Name of Minnesota licensed Supervisor"
                }
            },
            getSSSectionLabel() {
                if (this.technicianApplication.subCategory === 'GUEST') {
                    return "Sponsor" 
                } else {
                    return "Supervisor"
                }
            },
            getSupEstLabel() {
                if (this.technicianApplication.subCategory === 'GUEST') {
                    return "Name of Sponsoring Establishment"
                } else {
                    return "Name of establishment where you were supervised"
                }
            },
        },
        methods: {
            loadDayTypes() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/public/dayTypes`, { ignoreHeader: true })
                    .then(response => {
                        for (let type of response.data) {
                            this.opts.dayTypeOptions.push({
                                value: type.code,
                                text: type.description
                            })
                        }
                    })
            },
            addSupervisor: function () {
                if (this.isGuestApp) {
                    this.mnSupervisor.push({
                        id: null,
                        name: null,
                        licenseNbr: null,
                        workDate: {
                            id: null,
                            startDate: '',
                            endDate: '',
                        },
                        establishment: {
                            establishmentId: null,
                            supervisedEstName: null,
                            supervisedEstFullAddress: null,
                            supervisedEstWebsite: null,
                            supervisedEstLicense: null,
                            supervisedEstPhoneNumber: null,
                            establishmentHours: [{
                                id: null,
                                hours: null,
                                days: []
                            }],
                        }
                    });
                } else {
                    this.mnSupervisor.push({
                        id: null,
                        name: null,
                        licenseNbr: null,
                        workDate: null,
                        establishment: {
                            establishmentId: null,
                            supervisedEstName: null,
                            supervisedEstFullAddress: null,
                            supervisedEstWebsite: null,
                            supervisedEstLicense: null,
                            supervisedEstPhoneNumber: null,
                            establishmentHours: [{
                                id: null,
                                hours: null,
                                days: []
                            }],
                        }
                    });
                }
            },
            removeSupervisor: function (i) {
                this.$delete(this.mnSupervisor, i)
                this.mnSupervisor.splice()
            },
            addEstHours: function (i) {
                this.mnSupervisor[i].establishment.establishmentHours.push({
                    id: null,
                    hours: null,
                    days: []
                });
            },
            removeEstHours: function (i, i2) {
                this.$delete(this.mnSupervisor[i].establishment.establishmentHours, i2)
            },
            addEmployer: function () {
                this.employers.push({
                    employerId : null,
                    applicatonId: null,
                    name: null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    postalCode: null,
                    phone: null,
                    emailAddress: null,
                    startDate: null,
                    endDate: null
                });
            },
            removeEmployer: function (i) {
                this.$delete(this.employers, i)
            },
            validate() {
                this.$v.form.$touch();
                var isValid
                isValid = !this.$v.form.$invalid
                if (this.isGuestApp && isValid &&
                    !(this.validateDates(this.mnSupervisor, this.technicianApplication) && this.validateYear(this.mnSupervisor))) {
                    isValid = false;
                }
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },           
            updateEmployer(values, idx) {
                //set values
                this.employers[idx].name = values.name

                document.getElementById('name'+idx).value = values.name;
                document.getElementById('streetAddress'+idx).value = values.streetAddress;
                document.getElementById('city'+idx).value = values.city;
                document.getElementById('state'+idx).value = values.state;
                document.getElementById('postalCode'+idx).value = values.postalCode;
                document.getElementById('phone'+idx).value = values.phone;
                document.getElementById('emailAddress'+idx).value = values.emailAddress;
                document.getElementById('startDate'+idx).value = values.startDate;
                document.getElementById('endDate'+idx).value = values.endDate;

                //send change event
                document.getElementById('name'+idx).dispatchEvent(new Event('change'));
                document.getElementById('streetAddress'+idx).dispatchEvent(new Event('change'));
                document.getElementById('city'+idx).dispatchEvent(new Event('change'));
                document.getElementById('state'+idx).dispatchEvent(new Event('change'));
                document.getElementById('postalCode'+idx).dispatchEvent(new Event('change'));
                document.getElementById('phone'+idx).dispatchEvent(new Event('change'));
                document.getElementById('emailAddress'+idx).dispatchEvent(new Event('change'));
                document.getElementById('startDate'+idx).dispatchEvent(new Event('change'));
                document.getElementById('endDate'+idx).dispatchEvent(new Event('change'));
            },

            setName(licenseNbr, index) {
                if (licenseNbr && licenseNbr.length === 6) { 
                    let payload = {
                        number: licenseNbr,
                        licenseType: this.technicianApplication.license.licenseType
                    }
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/license/validate/license`, payload)
                        .then(response => {
                            if (response.data.status) {
                                this.mnSupervisor[index].name = response.data.fullName
                            } else {
                                this.mnSupervisor[index].name = null
                            }
                        });
                } else {
                    this.mnSupervisor[index].name = null
                }
            }
        },
        mounted() {
            this.loadDayTypes()
            if (this.technicianApplication.subCategory !== 'FULL') {
                this.employers = null
            }
        },
    }
</script>